export enum ObjectTypeEnum {
    CAMPAIGN = 'campaign',
    ADSET = 'adsets',
    AD = 'ads'
}

export type ObjectType = ObjectTypeEnum.CAMPAIGN | ObjectTypeEnum.ADSET | ObjectTypeEnum.AD; 